import React, { useContext, useState, useEffect, useCallback } from 'react';
import Select from 'react-select';
import './Navigation.css';
import axiosInstance from '../api/axios';
import AuthContext from "../context/AuthProvider";
import { trackPromise } from 'react-promise-tracker';

import ReportData from './ReportData';
import ReportNoData from './ReportNoData';
import ReportTree from './ReportTree';

const colourStyles = {
    control: base => ({
        ...base,
        fontSize: '14px'
    }),
    container: base => ({
        ...base,
        flex: 1
    }),
    menu: base => ({
        ...base,
        fontSize: '14px'
    }),
    placeholder: (styles) => {
        return {
            ...styles,
            fontSize: '14px',
        }
    },
    groupHeading: (styles) => {
        return {
            ...styles,
            fontSize: '16px',
            fontWeight: 'bold',
        }
    },

    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
        
        return {
            ...styles,
            fontSize: '14px',
            backgroundColor: isFocused ? "#CACACA" : null,
            color: "#333333",
            width: "auto"
        };
    }
};
const options = [];

const Navigation = () => {
    const { auth } = useContext(AuthContext);
    const username = auth.user;
    const token = auth.token;
    
    const studiesDefaultOption = { label: "Selecione o estudo", value: "" }
    const [selectedStudy, setSelectedStudy] = useState(studiesDefaultOption);
    const [studyName,setStudyName] = useState("");
    const [studyId,setStudyId] = useState('');
    const [quadros, setQuadros] = useState([]);
    const [quadrosTexto, setQuadrosTexto] = useState([]);
    const [treeData, setTreeData] = useState([]);
    const [hasTree,setHasTree] = useState(false);
    const [hasData, setHasData] = useState(false);
    const [selectedNode, setSelectedNode] = useState('');
    const [selectedNodeLabel, setSelectedNodeLabel] = useState('');
    const [selectedQuadro, setSelectedQuadro] = useState(null);
    const [parentNode,setParentNode] = useState('');    

    const getStudies = useCallback(async () => {
        const response = await axiosInstance.post("/report/getstudies",
            {},
            {
                params: {
                    username,
                    token
                }
            }
        );
        try {
            const result = await response.data;
            const studiesGroups = JSON.parse(result);
            
            for (let i = 0; i < studiesGroups.length; i++) {
                var optionsGroup = [];
                var waveItems = studiesGroups[i].waveItems;
                for (let n = 0; n < waveItems.length; n++) {
                    optionsGroup[n] = { value: waveItems[n].id, label: waveItems[n].name };
                }
                options[i] = { label: studiesGroups[i].name, options: optionsGroup };
            }
        } catch (err) {
            alert("Falha de comunicação com o servidor ao obter os resultados. Por favor, contate o serviço técnico da DATA E.");
            if (!err?.response) {
                console.error('ERRO [Report, Navigation, getStudies] Falha ao obter resultados da operação',err);
            }
        }
    }, [username, token]);

    useEffect(()=>{        
        trackPromise(getStudies());        
    }, [getStudies]);

    const getQuadros = async (studyId) => {
        const response = await axiosInstance.post("/report/getquadros",
            {},
            {
                params: {
                    username,
                    token,
                    studyId
                }
            });

        try {
            const result = await response.data;
            var quadrosJSON = JSON.parse(result);
            setQuadros(quadrosJSON);
            return quadrosJSON;
            
        } catch (err) {
            alert("Falha de comunicação com o servidor ao obter os resultados. Por favor, contate o serviço técnico da DATA E.");
            if (!err?.response) {
                console.error('ERRO [Report, Navigation, getQuadros] Falha ao obter resultados da operação',err);
            }
        }
    }

    const getQuadrosTexto = async (studyId) => {
        const response = await axiosInstance.post("/report/getquadrostexto",
            {},
            {
                params: {
                    username,
                    token,
                    studyId
                }
            });

        try {
            const result = await response.data;
            var quadrosTextoJSON = JSON.parse(result);
            setQuadrosTexto(quadrosTextoJSON);
            return quadrosTextoJSON;
            
        } catch (err) {
            alert("Falha de comunicação com o servidor ao obter os resultados. Por favor, contate o serviço técnico da DATA E.");
            if (!err?.response) {
                console.error('ERRO [Report, Navigation, getQuadrosTexto] Falha ao obter resultados da operação',err);
            }
        }
    }

    const getTree = async (studyId) => {
        const response = await axiosInstance.post("/report/gettree",
            {},
            {
                params: {
                    username,
                    token,
                    studyId
                }
            });

        try {
            const result = await response.data;
            setTreeData([]);
            var treeJSON = JSON.parse(result);            

            const protectIds = (nodes) => {
                if (!nodes) return [];
                return nodes.map(n => ({
                    ...n,
                    key: String(n.key), 
                    realnodeid: String(n.key),
                    nodes: protectIds(n.nodes)
                }));
            };

            const safeTree = protectIds(treeJSON);
            setTreeData(safeTree);
            if (safeTree.length > 0) {
                setHasTree(true);                         
            }
            return safeTree;
            
        } catch (err) {
            alert("Falha de comunicação com o servidor ao obter os resultados. Por favor, contate o serviço técnico da DATA E.");
            if (!err?.response) {
                console.error('ERRO [Report, Navigation, getTree] Falha ao obter resultados da operação',err);
            }
        }
    }    

    const handleStudyChange = (selectedStudy) => {
        setSelectedStudy(selectedStudy);
        setStudyId(selectedStudy.value);
        setStudyName(selectedStudy.label);
        setQuadros([]);
        setQuadrosTexto([]);
        setTreeData([]);
        const promises = [];
        promises.push(getQuadros(selectedStudy.value));
        promises.push(getQuadrosTexto(selectedStudy.value));
        promises.push(getTree(selectedStudy.value));
        Promise.all(promises)
            .then((result)=>{
                var q = result[0] || [];
                var t = result[2] || [];
                
                // Verificamos se a árvore tem dados antes de aceder ao 1º nó
                if (t && t.length > 0) {
                    var firstNode = t[0];
                    
                    setSelectedNode(firstNode.realnodeid);
                    setSelectedNodeLabel(firstNode.label);
                    
                    const quadroAux = q.find((quad) => String(quad.id) === String(firstNode.realnodeid)); 
                    setSelectedQuadro(quadroAux);
                    setHasData(true);
                } else {
                    // Se o estudo não tiver árvore configurada, protegemos a app
                    setHasData(false);
                    setHasTree(false);
                }
            })
            .catch((error)=>{
                alert("Falha de comunicação com o servidor ao obter os resultados. Por favor, contate o serviço técnico da DATA E.");
                if (!error?.response) {
                    console.error('ERRO [Report, Navigation, handleStudyChange] Falha ao obter resultados da operação', error);
                }
            });     
    };    

    const getQuadro = (quadroId) => {
        const quadro = quadros.find((q) => String(q.id) === String(quadroId));        
        return quadro;
    }

    const handleTreeClick = (node) => {
        setHasData(false);
        
        var nodeId = node.realnodeid; 
        
        var nodeLabel = node.label;
        var nodeParentId= node.parent;
        setSelectedNode(nodeId);
        setSelectedNodeLabel(nodeLabel);
        var quadro = getQuadro(nodeId);
        setSelectedQuadro(quadro);        
        setParentNode(nodeParentId);
        setHasData(true);        
    }
    
    return (
        <div style={{ padding: 10, color: "white", backgroundColor: "#6B747F" }}>
            <table style={{width: "100%"}}>
                <tbody>
                <tr>
                    <td style={{ width: "20%", verticalAlign: "top", paddingTop: "2px", paddingBottom: "2px" }}>        
                        <nav style={{ verticalAlign: "top" }}>
                            <div  style={{ padding: 5}}>
                                <ul>
                                    <h5>Estudo</h5>
                                    <Select options={options}
                                        value={selectedStudy}
                                        styles={colourStyles}
                                        isClearable={false}
                                        onChange={handleStudyChange} />
                                </ul>
                            </div>
                        </nav>                                        

                        {hasTree &&
                            <ReportTree treeData={treeData} handler={handleTreeClick}/>
                        }
                    </td>
                    <td colSpan={2} style={{ width: "100%", verticalAlign: "top", paddingTop: "2px", paddingBottom: "2px" }}>
                       {hasData && <div>
                        <ReportData 
                            username={username}
                            token={token}
                            studyId={studyId}
                            studyName={studyName}
                            selectedNode={selectedNode} 
                            selectedNodeLabel={selectedNodeLabel}
                            quadro={selectedQuadro} 
                            quadros={quadros} 
                            quadrosTexto={quadrosTexto} 
                            parentNode={parentNode}
                        />
                       </div>}
                       {!hasData && <div>
                            <ReportNoData title1="" title2="Benvindo ao SoftData Report." title3="Por favor selecione o estudo no canto superior esquerdo."
                                />
                        </div>}

                    </td>
                </tr>
                </tbody>
            </table>
        </div>

    );
};
export default Navigation;